import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";

export const styles = (theme: Theme) => {
	return {
		tags: {
			maxHeight: 128,
			overflowY: "auto",
		},
		helperText: {
			paddingLeft: 20,
		},
		helperTextP: {
			boxSizing: "border-box",
			margin: "10px 0px",
			padding: 0
		},
		button: {
			"&:active": {
				backgroundColor: theme.palette.action.disabledBackground,
				color: theme.palette.text.disabled,
			}
		},
	} satisfies Record<string, CSSObject>;
};
